import axios from 'axios';
import { apiConfigHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';
import type { DealLifecycle } from '@makemydeal/dr-dash-bff-types';
import { getCurrentAxiosRequestInterceptor } from '@makemydeal/dr-shared-network';

import {
    UPDATE_DEAL_LIFE_CYCLE_FAILURE,
    UPDATE_DEAL_LIFE_CYCLE_READY,
    UPDATE_DEAL_LIFE_CYCLE_REQUEST,
    UPDATE_DEAL_LIFE_CYCLE_SUCCESS,
    SHOW_DEAL_LIFE_CYCLE_MODAL,
    SET_DEAL_LIFE_CYCLE_MODAL_LOADER
} from '../actionTypes/dealLifeCycleActionTypes';
import { dealerSelectors, selectedOfferSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { paymentActionCreators } from '@makemydeal/dr-offer-redux';
import { dateUtils } from '@makemydeal/dr-common-utils';

export const updateDealLifeCycleData =
    (appPrefix: string, dealLifeCycleData: any, enableDealLifeCycleUpdates: boolean = true) =>
    async (dispatch: any, getState: any) => {
        const locHref = locHrefUtil.getLocHref();
        const dealXgId = selectedOfferSelectors.getSelectedOfferDealXgId(getState());
        const axiosRequestInterceptor = getCurrentAxiosRequestInterceptor();
        const endpoint = apiConfigHelper.buildBffApiUrl(appPrefix, locHref, `/deal/${dealXgId}/dealLifeCycle`).url;

        const { headers } = await axiosRequestInterceptor({
            url: endpoint
        });

        // dont dispatch updateDealLifeCycleRequest if it is summary tab
        if (enableDealLifeCycleUpdates) dispatch(updateDealLifeCycleRequest());
        dispatch(setDealLifeCycleModalLoader(true));

        try {
            const response = await axios.post(endpoint, dealLifeCycleData, {
                headers: {
                    Authorization: headers.Authorization
                }
            });

            dispatch(updateDealLifeCycleSuccess(response.data, enableDealLifeCycleUpdates));
            const state = getState();
            if (!featureToggleSelectors.isRemovePSCallOnContractDateUpdateEnabled(state)) {
                if (featureToggleSelectors.isDealerTimeZoneForContractDateEnabled(state)) {
                    // Forward the raw signed contract date and let the payment service resolve it in the
                    // dealer's timezone rather than formatting it here.
                    dispatch(paymentActionCreators.updateContractDate(dealLifeCycleData.contractSignedDate || undefined, true));
                } else if (dealerSelectors.isBaseDealExperience(state)) {
                    // Legacy: base-only, UTC-derived value.
                    dispatch(
                        paymentActionCreators.updateContractDate(
                            dealLifeCycleData.contractSignedDate
                                ? dateUtils.formatUtcDateTimeToDateOnly(dealLifeCycleData.contractSignedDate, 'yyyymmdd')
                                : undefined,
                            true
                        )
                    );
                }
            }
        } catch (err) {
            //  eslint-disable-next-line no-console
            console.error(`Error calling dealLifeCycle dash bff endpoint: ${err}`);

            if (enableDealLifeCycleUpdates) dispatch(updateDealLifeCycleFailure());
        } finally {
            dispatch(setDealLifeCycleModalLoader(false));
        }
    };

export const updateDealLifeCycleReady = () => ({ type: UPDATE_DEAL_LIFE_CYCLE_READY });
export const updateDealLifeCycleRequest = () => ({ type: UPDATE_DEAL_LIFE_CYCLE_REQUEST });
export const updateDealLifeCycleSuccess = (payload: DealLifecycle, enableDealLifeCycleUpdates: boolean) => ({
    type: UPDATE_DEAL_LIFE_CYCLE_SUCCESS,
    payload: { ...payload, enableDealLifeCycleUpdates }
});
export const updateDealLifeCycleFailure = () => ({ type: UPDATE_DEAL_LIFE_CYCLE_FAILURE });
export const showDealLifeCycleModal = (showDealLifeCycleModal: boolean) => ({
    type: SHOW_DEAL_LIFE_CYCLE_MODAL,
    payload: { showDealLifeCycleModal }
});
export const setDealLifeCycleModalLoader = (showDealLifeCycleModalLoader: boolean) => ({
    type: SET_DEAL_LIFE_CYCLE_MODAL_LOADER,
    payload: { showDealLifeCycleModalLoader }
});
